import { render } from "./card-opportunities.vue?vue&type=template&id=7d23d774&scoped=true&ts=true"
import script from "./card-opportunities.vue?vue&type=script&lang=ts"
export * from "./card-opportunities.vue?vue&type=script&lang=ts"

import "./card-opportunities.vue?vue&type=style&index=0&id=7d23d774&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d23d774"]])

export default __exports__